import { createActionGroup, props } from "@ngrx/store";

export const paymentStateActions = createActionGroup({
  source: 'State/API',
  events: {
    'Load Flight Offer Data': props<{ flightOfferId: string }>(),
    'Load Flight Offer Data Success': props<{ data: { flightOffer: any } }>(),
    'Load Flight Offer Data Failure': props<{ data: any }>(),
    'Order Flight': props<{ flightOffer: any, orderInformation: any }>(),
    'Order Flight Success': props<{ data: { flightOrder: any } }>(),
    'Order Flight Failure': props<{ data: any }>(),
    // 'Load States': props<{ states: State[] }>(),
    // 'Add State': props<{ state: State }>(),
    // 'Upsert State': props<{ state: State }>(),
    // 'Add States': props<{ state: State[] }>(),
    // 'Upsert States': props<{ state: State[] }>(),
    // 'Update State': props<{ state: Update<State> }>(),
    // 'Update States': props<{ states: Update<State>[] }>(),
    // 'Delete State': props<{ id: string }>(),
    // 'Delete States': props<{ ids: string[] }>(),
    // 'Clear States': emptyProps(),
  }
});
